export default __webpack_public_path__ + "a020ba77a9e60b3ab59df0f9d798f142.webp";